import 'sweetalert2/dist/sweetalert2.min.css';
import 'element-ui/lib/theme-chalk/index.css';
import lang from 'element-ui/lib/locale/lang/vi';
import locale from 'element-ui/lib/locale';
import VueSweetalert2 from 'vue-sweetalert2';
import Vue from 'vue';
import { Tooltip, Loading, Upload, Drawer, ColorPicker, Slider } from 'element-ui';

locale.use(lang);
Tooltip.props.enterable.default = false;
Vue.use(Tooltip);
Vue.use(Loading);
Vue.use(Upload);
Vue.use(Drawer);
Vue.use(ColorPicker);
Vue.use(Slider);
Vue.use(VueSweetalert2);
